<template>
    <SimpleTablePage
        :pageTitle="$t('zhiji.knowlege.matchTitle')"
        :filters="searchFilter"
        :columns="columns"
        :dataset="dataset"
        :isHideFooter="true"
        @filterChange="filterFieldsChange"
    >
        <div slot="operation">
            <div class="page-top-tips">{{ $t("zhiji.knowlege.funcDescription") }}</div>
        </div>
        <div slot="beforeTable" class="online-tips">
            {{ $t("zhiji.knowlege.ACresult") }}
            <span v-show="isHitQuery" class="fail-tips">
                {{ $t("zhiji.knowlege.unExist") }} <i>{{ $t("zhiji.knowlege.describe") }}</i> {{ $t("zhiji.knowlege.Configured") }}。
                <el-link type="primary" @click="goNewPage">{{ $t("zhiji.knowlege.createQues") }} ></el-link>
            </span>
        </div>
        <div slot="bottom">
            <div class="real-algorithm-tips">
                {{ $t("zhiji.knowlege.ALresult") }}
                <span>{{ $t("zhiji.knowlege.ALresultTip") }}</span>
            </div>
            <Table style="margin-bottom:30px;" :cur-page="1" :config="tableConfig" :dataset="realAlgDataset" />
        </div>
    </SimpleTablePage>
</template>

<script>
import { quesListTable, searchFilter } from "./onlineTestConfig";
import { debounce } from "@/views/zhiji/js/common/util.js";
import { businessLangs } from "@/components/langSelect/languages.js";
import SimpleTablePage from "@/views/zhiji/templates/simpleTablePage/index.vue";
import Table from "@/views/zhiji/bComponents/newTable/Table.vue";

const langOptions = () => {
    let langs = businessLangs().map(lang => {
        return {
            value: lang.lang,
            i18nKey: lang.i18nKey
        };
    });
    return [...langs];
};

export default {
    name: "QAMatchingTest",
    components: {
        Table,
        SimpleTablePage
    },
    data() {
        return {
            dataset: [],
            realAlgDataset: [],
            debouncedQuery: null,
            matchFilterFields: {
                btn: 0
            }
        };
    },
    created() {
        window.addEventListener("keyup", this.windowClick);
        this.debouncedQuery = debounce(request => {
            this.queryList(request);
        }, 1000);
    },
    beforeDestroy() {
        window.removeEventListener("keyup", this.windowClick);
    },
    computed: {
        pageTitle() {
            return this.$t("zhiji.answer.onlineQAMatchTitle");
        },
        tableConfig() {
            return { ...quesListTable(), isHideFooter: true };
        },
        columns() {
            return quesListTable().columns;
        },
        channelOpts() {
            return this.$store.state.auth.businessSetting.robots.flatMap(item => item.source);
        },
        langOpts() {
            return langOptions()
        },
        searchFilter() {
            return searchFilter(this.channelOpts, this.langOpts);
        },
        isHitQuery() {
            if (this.dataset.length > 0) {
                return !this.dataset[0].addData.hit_query;
            }
            return false;
        }
    },
    methods: {
        queryList(request) {
            const obj = request[0];
            if (Object.keys(obj).length >= 3 && Object.values(obj).every(value => value !== "")) {
                this.zhiji
                    .requestByServiceName("queryQaList", {
                        page: 1,
                        size: 10,
                        request
                    })
                    .then(res => {
                        this.dataset = res.list;
                    });
                this.zhiji
                    .requestByServiceName("searchQuestionOne", {
                        page: 1,
                        size: 10,
                        question: obj.question,
                        lang: obj.lang,
                    })
                    .then(res => {
                        this.realAlgDataset = res.dataset;
                    });
            } else {
                this.dataset = [];
                this.realAlgDataset = [];
                return;
            }
        },
        filterFieldsChange({ matchFilterFields }) {
            if (matchFilterFields.btn && this.matchFilterFields.btn !== matchFilterFields.btn) {
                this.debouncedQuery(matchFilterFields);
            }
            this.matchFilterFields = matchFilterFields;
        },
        goNewPage() {
            window.open("/index.html#/knowledge/questionlist", "_blank");
        },
        windowClick(event) {
            if (event.code === "Enter") {
                this.debouncedQuery(this.matchFilterFields);
            }
        }
    }
};
</script>

<style lang="less" scoped>
/deep/.simple-table-page-operation {
    height: 95px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .simple-table-page-filter {
        justify-content: start;
    }
}
/deep/ .simple-table-page-operation-btns {
    width: 100%;
}
.page-top-tips {
    max-width: max-content;
    border: 1px solid #2ec2ff;
    border-radius: 3px;
    padding: 6px 8px;
    margin-bottom: 12px;
    margin-top: 10px;
    background-color: rgba(46, 194, 255, 0.06);
}

.online-tips,
.real-algorithm-tips {
    font-size: 14px;
    color: #41475e;
    font-weight: 500;
    position: relative;
    margin: 20px 0 8px 18px;
}

.fail-tips {
    margin-left: 10px;
    font-size: 12px;
    color: #999;
    i {
        color: #ff9e0d;
    }
}

.online-tips::before,
.real-algorithm-tips::before {
    content: "";
    position: absolute;
    top: 7px;
    left: -15px;
    width: 4px;
    height: 8px;
}

.online-tips::before {
    background: #03c972;
}

.real-algorithm-tips::before {
    background: #2ec2ff;
}

.real-algorithm-tips span {
    margin-left: 10px;
    font-size: 12px;
    color: #999;
}
.wrapper {
    margin-top: -20px;
    box-sizing: border-box;
    margin-right: 522px;
}
.match-input {
    width: 680px;
}
.match-btn {
    vertical-align: middle;
    margin-bottom: 5px;
    margin-left: 10px;
}
/deep/ .el-icon-circle-close:before {
    color: #939eaa;
}
</style>
